import classNames from "classnames";
import { FC } from "react";
import DescriptionBlock from "@/pages/quiz/base/components/progressHeader/components/DescriptionBlock";
import { QuestionDescriptionBlock } from "@/types";

interface QuestionContentDisplayProps {
  question: string;
  prompt?: string;
  customHTML?: string;
  descriptionBlock?: QuestionDescriptionBlock;
  className?: string;
}

// Replaces normal hyphens "-" (U+002D) with non-breaking hyphens (U+2011).
// Prevents browsers (especially Chrome) from breaking words.
const noBreakHyphens = (value: string) => value.replace(/-/g, "\u2011");

const QuestionContentDisplay: FC<QuestionContentDisplayProps> = ({
  question,
  prompt,
  customHTML,
  descriptionBlock,
  className,
}) => (
  <div className={classNames("mb-4 sm:mb-4 space-y-4", className)}>
    <h2
      className={classNames(
        "section-title",
        "whitespace-normal",
        "break-keep",
        "hyphens-none"
      )}
    >
      {noBreakHyphens(question)}
    </h2>
    {prompt && <p className="quiz-description">{prompt}</p>}
    {customHTML && (
      <div
        className="quiz-description"
        dangerouslySetInnerHTML={{ __html: customHTML }}
      />
    )}
    {descriptionBlock && (
      <DescriptionBlock descriptionBlock={descriptionBlock} />
    )}
  </div>
);

export default QuestionContentDisplay;
